import React, { useState, useEffect } from "react";
import StatusIcon from "../../../../icons/status.icon";
import TagIcon from "../../../../icons/tag.icon";
import AssignIcon from "../../../../icons/assign.icon";
import ArchiveBoxIcon from "../../../../icons/archive-boxtag.icon";
import CrossIcon from "../../../../icons/cross.icon";
import styles from "./selected-accounts-actions-bottom-modal.module.scss";

export const SelectedAccountsActionsBottomModal = ({
  show,
  onHide,
  selectedCount = 0,
  onStatusClick,
  onTagClick,
  onAssignClick,
  onArchiveClick,
  showStatusModal = false,
  showTagsModal = false,
  showAssignModal = false,
  showArchiveModal = false,
}) => {
  const [activeAction, setActiveAction] = useState(null);

  // Reset activeAction when the corresponding modal closes
  useEffect(() => {
    if (activeAction === "status" && !showStatusModal) {
      setActiveAction(null);
    } else if (activeAction === "tag" && !showTagsModal) {
      setActiveAction(null);
    } else if (activeAction === "assign" && !showAssignModal) {
      setActiveAction(null);
    } else if (activeAction === "archive" && !showArchiveModal) {
      setActiveAction(null);
    }
  }, [activeAction, showStatusModal, showTagsModal, showAssignModal, showArchiveModal]);

  const bulkActions = [
    {
      id: "status",
      icon: StatusIcon,
      label: "Status",
      isActive: false,
    },
    {
      id: "tag",
      icon: TagIcon,
      label: "Tag",
      isActive: false,
    },
    {
      id: "assign",
      icon: AssignIcon,
      label: "Assign",
      isActive: false,
    },
    {
      id: "archive",
      icon: ArchiveBoxIcon,
      label: "Archive",
      isActive: false,
    },
  ];

  const handleActionClick = (actionId) => {
    setActiveAction(actionId);
    if (actionId === "status" && onStatusClick) {
      onStatusClick();
    } else if (actionId === "tag" && onTagClick) {
      onTagClick();
    } else if (actionId === "assign" && onAssignClick) {
      onAssignClick();
    } else if (actionId === "archive" && onArchiveClick) {
      onArchiveClick();
    }
  };

  if (!show) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.toolbar} role="toolbar" aria-label="Bulk actions toolbar">
        <div className={styles.selectedCountText}>
          {selectedCount}
        </div>

        <div className={styles.itemsSelectedText}>
          items selected
        </div>

        <div className={styles.actionsContainer}>
          {bulkActions.map((action) => {
            const IconComponent = action.icon;
            const isActive = action.id === activeAction;

            return (
              <button
                key={action.id}
                type="button"
                onClick={() => handleActionClick(action.id)}
                className={`${styles.actionButton} ${
                  isActive ? styles.actionButtonActive : ""
                }`}
                aria-label={action.label}
                aria-pressed={isActive}
              >
                <div className={styles.iconWrapper}>
                  <IconComponent 
                    className={styles.icon} 
                    fill={isActive ? "#008FD4" : "#616778"}
                    width={16}
                    height={16}
                    style={{ width: '16px', height: '16px' }}
                  />
                </div>

                <div className={styles.labelWrapper}>
                  <div
                    className={`${styles.label} ${
                      isActive ? styles.labelActive : styles.labelInactive
                    }`}
                  >
                    {action.label}
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        <button
          type="button"
          onClick={onHide}
          className={styles.closeButton}
          aria-label="Close bulk actions"
        >
          <div className={styles.closeIconWrapper}>
            <CrossIcon 
              className={styles.closeIcon} 
              fill="#616778"
              width={13}
              height={13}
              style={{ width: '13px', height: '13px' }}
            />
          </div>
        </button>
      </div>
    </div>
  );
};